import React from "react";
import { Popup } from "react-map-gl";
import { statesViews } from "../../constants";
import {
  StyledPopup,
  PopupHeader,
  PopupTitle,
  PopupContent,
} from "../Popup/styled";

function StatePopup({ className, data, view, children, ...props }) {
  return (
    <StyledPopup className={className} {...props} as={Popup}>
      <PopupHeader>
        <PopupTitle>
          {data.name}{" "}
          <span>
            #
            {view === statesViews.CAPACITY
              ? data.total_solar_school_energy_capacity_rank
              : data.number_solar_schools_rank}
          </span>
        </PopupTitle>
      </PopupHeader>
      <PopupContent>
        {view === statesViews.CAPACITY ? (
          <p>
            <span>Total Solar Capacity:</span>{" "}
            {data.total_solar_school_energy_capacity.toLocaleString("en-US")} kW
          </p>
        ) : (
          <p>
            <span>Number of Solar Schools:</span>{" "}
            {data.number_solar_schools.toLocaleString("en-US")}
            <br />
            {/* <span>Number of Schools:</span> {parseFloat(data.number_schools)} */}
          </p>
        )}
        {data.state_resources && (
          <a href={data.state_resources} target="_blank" rel="noreferrer">
            State Resources
          </a>
        )}
      </PopupContent>
    </StyledPopup>
  );
}

export default StatePopup;
